import { combineReducers } from "redux";
import { State } from "state/reducers/Reducers";

export const rootReducer = combineReducers({
  State
});

export type RootState = ReturnType<typeof rootReducer>;
